import {
    GETCHARGEMASTERLIST_SUCCESS,
    GETCHARGEMASTERLIST_FAILED,
    RESET_GETCHARGEMASTERLIST,
    LOADING_GETCHARGEMASTERLIST,
    NETWORK_ERROR_GETCHARGEMASTERLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETCHARGEMASTERLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETCHARGEMASTERLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETCHARGEMASTERLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETCHARGEMASTERLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETCHARGEMASTERLIST:
            return (state = initialState);
        default:
            return state;
    }
};
